import { createContext, useContext } from "react";

/** Minimize control supplied by `WindowMinimizeContext` and accepted by `WindowChromeControls`. */
export interface WindowMinimize {
    minimized: boolean;
    onToggle: () => void;
}

export const WindowMinimizeContext = createContext<WindowMinimize | null>(null);

export function useWindowMinimize(): WindowMinimize | null {
    return useContext(WindowMinimizeContext);
}
